'use client';

import type { ReactNode } from 'react';
import { Footer } from '@/app/components/layouts/demo7/components/footer';
import { HeaderMobile } from '@/app/components/layouts/demo7/components/header-mobile';
import { AppSidebar } from './AppSidebar';
import { AppTopBar } from './AppTopBar';

export function AppShell({
  children,
  isFullWidth,
  hideFooter,
}: {
  children: ReactNode;
  isFullWidth: boolean;
  hideFooter: boolean;
}) {
  return (
    <div className="flex min-h-dvh w-full">
      <AppSidebar />
      <div className="flex min-w-0 grow flex-col">
        <header className="fd-header sticky top-0 z-50 shrink-0 border-b border-[var(--fd-line)] lg:hidden">
          <HeaderMobile variant="app" display="flex lg:hidden" />
        </header>
        <AppTopBar />
        <main
          className={`grow min-w-0 min-h-[calc(100vh-var(--header-height,64px))] lg:min-h-0 mx-auto w-full${isFullWidth ? '' : ' max-w-[1320px]'}`}
        >
          {children}
        </main>
        {!hideFooter && <Footer />}
      </div>
    </div>
  );
}
